import { useIsAuthenticated } from '@azure/msal-react';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { checkIsInSessionRouteWithoutRouter } from '~/hooks/session/useIsInSessionRoute';
import { isMsalEnabled } from '~/lib/msal';

interface AuthenticationGuardProps {
    children: React.ReactNode;
}

/**
 * AuthenticationGuard component that protects routes requiring MSAL authentication.
 */
const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
    children,
}) => {
    const location = useLocation();
    const isAuthenticated = useIsAuthenticated();
    const isInConnectorRoute = checkIsInSessionRouteWithoutRouter();

    // Allow access if MSAL is disabled or if in connector route
    if (!isMsalEnabled() || isInConnectorRoute) {
        return <>{children}</>;
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return (
            <Navigate to="/login" state={{ from: location.pathname }} replace />
        );
    }

    // User is authenticated, render the protected content
    return <>{children}</>;
};

export default AuthenticationGuard;
